<template>
  <div>
    <v-text-field outlined
      label="Complemento"
      v-validate="validator"
      @input="$emit('input', $event)"
      :value="value"
      :error-messages="errors.first(field)"
      :name="field"
      v-bind="config" />
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    value: String,
    field: String,
    config: Object,
    validator: Object,
  },
}
</script>

<style>
</style>
